import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsFull() {
  const testimonials = [{
    initials: 'MP',
    text: 'Compré un sábado. El domingo a la noche tenía el mes de sesiones listo. Nunca más improviso.',
    name: 'Martín P.',
    location: 'Buenos Aires 🇦🇷'
  }, {
    initials: 'LG',
    text: 'Tres chicas Sub 15 que estaban estancadas subieron de nivel en el primer mes con el Tomo 8.',
    name: 'Laura G.',
    location: 'Córdoba 🇦🇷'
  }, {
    initials: 'FR',
    text: 'Antes tardaba 1 hora armando sesiones tácticas. Ahora son 5 minutos.',
    name: 'Federico R.',
    location: 'Rosario 🇦🇷'
  }, {
    initials: 'SV',
    text: 'Las fichas de evaluación del Bonus 6 eliminaron las preguntas de los padres. Ahora el progreso tiene números.',
    name: 'Sofía V.',
    location: 'Mendoza 🇦🇷'
  }, {
    initials: 'DA',
    text: 'Conseguí mi primer sponsor en 2 semanas usando el guion del Élite 2. Recuperé el precio del pack en una semana.',
    name: 'Diego A.',
    location: 'Santa Fe 🇦🇷'
  }, {
    initials: 'CR',
    text: 'El Planificador Anual me salvó la pretemporada. Llegué con todo organizado desde Enero.',
    name: 'Claudia R.',
    location: 'Tucumán 🇦🇷'
  }];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-304">
      <div className="max-w-6xl mx-auto" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-306">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-307">
            Lo que dicen los entrenadores
          </h2>
          <div className="flex justify-center gap-1 mb-2" data-id="element-308">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-orange text-orange" data-id="element-309" />)}
          </div>
          <p className="text-xl text-orange font-bold" data-id="element-310">4.9/5</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-311">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-bg-card border-l-4 border-orange rounded-card p-6" data-id="element-312">
              <div className="flex items-center gap-3 mb-4" data-id="element-313">
                <div className="w-12 h-12 rounded-full bg-orange flex items-center justify-center font-bold text-white" data-id="element-314">
                  {testimonial.initials}
                </div>
                <div data-id="element-315">
                  <p className="font-bold" data-id="element-316">{testimonial.name}</p>
                  <p className="text-sm text-text-secondary" data-id="element-317">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <p className="text-text-secondary italic" data-id="element-318">"{testimonial.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}